import WaypointsSection from "./WaypointsSection";

export default WaypointsSection;
